export default "__VITE_ASSET__DBQaaHnJ__"